import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function merchantsReducer(
  state = initialState.merchants,
  action
) {
  switch (action.type) {
    case types.GET_MERCHANTS_PAGE:
      return initialState.merchants;
    case types.GET_MERCHANTS_PAGE_FAILED:
      return action.error;
    case types.GET_MERCHANTS_PAGE_SUCCESS:
      return action.page;
    default:
      return state;
  }
}
